import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CompanyNavPageDataService {
  apiEP: string = window.apiUrl;

  constructor(private http: HttpClient) {}

  getMetaInfo(ticker, currency?): Observable<any> {
    let url = `${this.apiEP}/nav_page/get_nav_meta?ticker=${ticker}`;
    if (currency) {
      url += `&currency=${currency}`;
    }
    return this.http.get(url);
  }
  getSourcesList(ticker) {
    const url = `${this.apiEP}/nav_page/get_sources_for_custom_consensus?ticker=${ticker}`;
    return this.http.get(url);
  }

  getNotes(ticker, metaObj) {
    const sourceInfo = {};
    metaObj.sources_info.forEach((val) => {
      sourceInfo[val.sid] = {
        short_name: val.source_name,
        document_id: val.document_id,
      };
    });
    const url = `${this.apiEP}/nav_page/get_nav_notes`;
    const params = {
      ticker: ticker,
      sources_info: sourceInfo,
    };
    return this.http.post(url, params);
  }

  convertRowData(metaObj, columnList) {
    const rowData = [];
    metaObj.left_column_tag_list = Array.from(
      new Set(metaObj.left_column_tag_list),
    );
    for (let index = 0; index < metaObj.left_column_tag_list.length; index++) {
      const rowId = metaObj.left_column_tag_list[index];
      if (metaObj.left_column_tags_info[rowId]) {
        const rowObj = {
          lineInfo: {
            ...metaObj.left_column_tags_info[rowId],
            ctag: rowId,
          },
          navCols: {},
        };

        //update navCols as per source list
        const navColObj = {};
        for (let index = 0; index < columnList.length; index++) {
          const colObj = columnList[index];
          const sourceObj = {};
          navColObj[colObj.colId] = {
            data: sourceObj,
            parameterId: null,
          };

          for (let i = 0; i < colObj.sourceList.length; i++) {
            const sourceId = colObj.sourceList[i];
            const sourceName = metaObj.sources_info[sourceId]
              ? metaObj.sources_info[sourceId].short_name
              : "";
            sourceObj[sourceId] = {
              isLoading: true,
              val: null,
              isNegative: false,
              source: sourceName,
              currency: metaObj.currency,
              unit: metaObj.sources_info[sourceId]
                ? metaObj.sources_info[sourceId].unit
                : "",
              magnitude: metaObj.sources_info[sourceId]
                ? metaObj.sources_info[sourceId].magnitude
                : "",
              analystInfo: {},
            };
          }
        }
        rowObj.navCols = { ...navColObj };
        rowData.push(rowObj);
      }
    }

    return rowData;
  }
  getParameterIds(ticker, colIds, rowIds) {
    const url = `${this.apiEP}/nav_page/get_parameter_ids`;
    const params = {
      ticker: ticker,
      masterparameter_ids: colIds,
      ctag_ids: rowIds,
    };
    return this.http.post(url, params);
  }
  getRowsData(ticker, sourceIds, paramIds, metaObj, dataSettings?) {
    const precision = {};
    for (const key in metaObj.columns_info) {
      const element = metaObj.columns_info[key];
      precision[key] = element.precision ? element.precision : 2;
    }
    let sourceInfo = {};
    if (sourceIds.includes(10001)) {
      sourceInfo = metaObj.sourceDocMapping;
    } else {
      metaObj.sources_info.forEach((val) => {
        sourceInfo[val.sid] = {
          short_name: val.source_name,
          document_id: val.document_id,
        };
      });
    }
    const url = `${this.apiEP}/nav_page/get_nav_data`;
    const params = {
      ticker: ticker,
      sid: sourceIds,
      pid: paramIds,
      columns_precision: precision,
      masterparameter_dict: metaObj.masterparameter_dict,
      company_level_currency: metaObj.company_level_currency,
      sources_info: sourceInfo,
    };
    if (dataSettings) {
      if (dataSettings.revision) params["revision"] = dataSettings.revision;
      if (dataSettings.view_by) params["view_by"] = dataSettings.view_by[0];
      if (dataSettings.currency) params["currency"] = dataSettings.currency;
      if (dataSettings.customCC && dataSettings.customCC.length > 0)
        params["cc_sources"] = [...dataSettings.customCC];
    }
    return this.http.post(url, params);
  }

  getAnalystInfo(documentIds) {
    return this.http.post(`${this.apiEP}/nav_page/get_document_analyst`, {
      document_ids: documentIds,
    });
  }
  saveSettings(params, ticker) {
    params.keyChanged = "all";
    const jsonObj = {
      ticker: ticker,
      json_data: params,
    };
    return this.http.post(`${this.apiEP}/nav_page/save_nav_filters`, jsonObj);
  }

  navExport(ticker) {
    const url = `${this.apiEP}/addin/export?template_type=nav company export&ticker=${ticker}`;
    return this.http.get(url);
  }

  getSourcesInfo(
    ticker,
    viewBy,
    revision,
    masterparameter_dict,
    defaultSource,
  ) {
    const url = `${this.apiEP}/nav_page/get_sources_info`;
    const params = {
      ticker: ticker,
      view_by: viewBy,
      rev_date: revision,
      masterparameter_parameter_dict: masterparameter_dict,
      default_source: defaultSource,
    };
    return this.http.post(url, params);
  }
}

export interface NavRowData {}

export const NAV_PAGE = "NAV_PAGE";

export const NAV_LOG_ACTION_FEATURES = {
  visitPage: "NAV_PAGE_VISIT",
  ownershipColumnExpand: "OWNERSHIP_COLUMN_EXPAND",
  discountFactorColumnExpand: "DISCOUNT_FACTOR_COLUMN_EXPAND",
  attributableNavColumnExpand: "ATTRIBUTABLE_NAV_COLUMN_EXPAND",
  navPerShareColumnExpand: "NAV_PER_SHARE_COLUMN_EXPAND",
  navColumnExpand: "NAV_COLUMN_EXPAND",
  currencySelection: "CURRENCY_SELECTION",
  customConsensusSelection: "CUSTOM_CONSENSUS_SELECTION",
  revisionSelection: "REVISIONS_SELECTION",
  highLow: "HIGHLIGHT_HIGH_LOW_SELECTION",
  reitsNav: "REITS_NAV_COLUMN_EXPAND",
  valueOnlyExport: "NAV_VALUE_ONLY_EXPORT",
};
